import React, { useState, useEffect } from 'react';
import { CheckCircle, Clock, Square, User, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import SocialMediaCTA from '../components/SocialMediaCTA';

const LandmarkPage = () => {
  const [project, setProject] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/landmark-projects?limit=1`);
        if (response.ok) {
          const data = await response.json();
          if (data.projects.length > 0) {
            setProject(data.projects[0]);
          } else {
            setProject(null);
          }
        } else {
          setError('Failed to fetch landmark project');
        }
      } catch (error) {
        setError('Error fetching landmark project');
      }
    };
    fetchProject();
  }, []);

  if (error) {
    return <div className="text-red-500 text-center my-10">{error}</div>;
  }

  if (!project) {
    return <div className="text-center my-10">No available landmark projects</div>;
  }

  return (
    <div className="min-h-screen font-poppins">
      {/* Full-Width Image Hero Container */}
      <section
        className="relative min-h-[100vh] flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(http://localhost:5000${project.images[0].imageUrl})` }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70"></div>

        {/* Social Media Icons - Top Left (Fixed) */}
        <div className="fixed top-20 left-2 sm:left-4 z-20 flex flex-col space-y-2 sm:space-y-4">
          <a href="#" className="text-white hover:text-[#ECEE07] transition-colors duration-300">
            <Facebook size={20} />
          </a>
          <a href="#" className="text-white hover:text-[#ECEE07] transition-colors duration-300">
            <Twitter size={20} />
          </a>
          <a href="#" className="text-white hover:text-[#ECEE07] transition-colors duration-300">
            <Instagram size={20} />
          </a>
          <a href="#" className="text-white hover:text-[#ECEE07] transition-colors duration-300">
            <Linkedin size={20} />
          </a>
        </div>

        <div className="container mx-auto relative z-10 text-center px-4">
          {/* Text Overlay (Project Title & Description) */}
          <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 leading-tight">
            {project.title}
          </h1>
          <p className="text-gray-200 text-lg sm:text-xl md:text-xl mb-8 max-w-3xl mx-auto">
            {project.description.substring(0, 200)}...
          </p>

          {/* Social Media Icons */}
            <div className="absolute left-4 top-1/2 -translate-y-1/2 flex flex-col space-y-4">
              <a href="#" className="text-white hover:text-[#ECEE07] transition-colors duration-300">
                <Linkedin size={28} />
              </a>
              <a href="#" className="text-white hover:text-[#ECEE07] transition-colors duration-300">
                <Instagram size={28} />
              </a>
              <a href="#" className="text-white hover:text-[#ECEE07] transition-colors duration-300">
                <Facebook size={28} />
              </a>
            </div>
        </div>

        {/* Sticky Project Data Bar */}
        <div className="absolute bottom-0 left-0 right-0 bg-white py-3 sm:py-4 shadow-lg">
          <div className="container mx-auto flex flex-wrap justify-around items-center text-center">
            <div className="p-4 flex flex-col items-center">
              <Clock size={34} className="text-[#364A9A] mb-2" />
              <p className="text-gray-600 uppercase text-lg font-semibold">Completion</p>
              <p className="text-main-blue text-xl font-bold">{new Date(project.completionDate).toLocaleDateString()}</p>
            </div>
            <div className="p-4 flex flex-col items-center">
              <Square size={34} className="text-[#364A9A] mb-2" />
              <p className="text-gray-600 uppercase text-lg font-semibold">Location</p>
              <p className="text-main-blue text-xl font-bold">{project.location}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 02: Project Description */}
      <section className="bg-white py-12 sm:py-16">
        <div className="container mx-auto max-w-4xl px-4">
          <h2 className="text-[#364A9A] text-xl md:text-2xl font-bold mb-6">Project Description:</h2>
          <div className="text-gray-700 text-base md:text-lg leading-relaxed font-gilda">
            <p className="mb-4">
              {project.description}
            </p>
          </div>
        </div>
      </section>

      <SocialMediaCTA />
          
    </div>
  );
};

export default LandmarkPage;
